import { Button, ButtonGroup } from '@material-ui/core';
import React from 'react';
import { FilterIcon } from '../../../icons';

function FilterLineBeginning() {
    return (
        <ButtonGroup size="small" disableFocusRipple disableRipple className="searchfilter">
            <Button size="small" color="primary">
                <FilterIcon style={{ fontSize: '80%' }} color="white" />
            </Button>
        </ButtonGroup>
    );
}

export default FilterLineBeginning;
